document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('FacetFiltersForm');
  const status = document.getElementById('filter-status');
  if (!form) return;

  let debounceTimer;

  function announceAndSubmit() {
    clearTimeout(debounceTimer);

    if (status) {
      status.textContent = 'Filters are being applied. Please wait.';
    }

    debounceTimer = setTimeout(() => {
      form.submit();
    }, 500);
  }

  form.querySelectorAll('input').forEach(input => {
    input.addEventListener('change', announceAndSubmit);
  });
});

$(document).ready(function () {

  var lastFocusedSearchBtn;

 $(".offcanvas-btn").on("click", function () {
  lastFocusedSearchBtn = $(this);
  setTimeout(function () {
    $(".offcanvas-search-inner").attr("tabindex", 0).focus();
  }, 1000);
 });

 $(".offcanvas-close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedSearchBtn) {
      lastFocusedSearchBtn.attr("tabindex", 0).focus();
    }
  }, 1000);
 });

 $(document).on("keydown", function (e) {
  if (e.key === "Escape" && $(".offcanvas-search-inner").hasClass("show")) {
    $("body").removeClass("fix");
    $(".offcanvas-search-inner").removeClass("show");

    if (lastFocusedSearchBtn) {
      lastFocusedSearchBtn.focus();
    }
  }
});

   var lastFocusedCartDawer;

 $(".minicart-btn").on("click", function () {
  lastFocusedCartDawer = $(this);
  setTimeout(function () {
    $(".minicart-inner-content").attr("tabindex", 0).focus();
  }, 1000);
 });

 $(".minicart-close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedCartDawer) {
      lastFocusedCartDawer.attr("tabindex", 0).focus();
    }
  }, 1000);
 });

$(document).on("keydown", function (e) {
  if (e.key === "Escape" && $(".minicart-inner").hasClass("show")) {
    $("body").removeClass("fix");
    $(".minicart-inner").removeClass("show");

    if (lastFocusedCartDawer) {
      lastFocusedCartDawer.focus();
    }
  }
});

var lastFocusedMobileMenu;

 $(".off-canvas-btn").on("click", function () {
  lastFocusedMobileMenu = $(this);
  setTimeout(function () {
    $(".off-canvas-inner-content").attr("tabindex", 0).focus();
  }, 1000);
 });

 $(".btn-close-off-canvas").on("click", function () {
  setTimeout(function () {
    if (lastFocusedMobileMenu) {
      lastFocusedMobileMenu.attr("tabindex", 0).focus();
    }
  }, 1000);
 });

 $('a').filter('[target="_blank"]').append('<span class="visually-hidden">This link will open in a new tab.</span>');
    $('a[href^="tel:"]').each(function () {
        var number = $(this).text().trim().replace('tel:', ''); 
        var ariaLabel = 'Phone Number: ' + number;
        $(this).attr('aria-label', ariaLabel);
    });
    $('a[href^="mailto:"]').each(function () {
          var email = $(this).text().trim().replace('mailto:', '');
          var ariaLabel = 'Email Address: ' + email;
          $(this).attr('aria-label', ariaLabel);
});
$('br').attr('aria-hidden', 'true');
$(".error-ajax-popup .modal-close > button").on("click", function () {
   setTimeout(function () {
     $("#AddToCart").attr("tabindex", 0).focus();
   }, 1000);
});
function removeBrOnResize() {
        var windowWidth = $(window).width();

        if (windowWidth <= 326) {
            $('.hero-slider-content.slide-1 br').remove();
        }
    }

    removeBrOnResize();

    $(window).resize(function() {
        removeBrOnResize();
    });
    var lastFocusedButton = null;

jQuery(document).on("click", ".product-cart-action > .btn", function () {
    lastFocusedButton = jQuery(this);

    setTimeout(function () {
        jQuery("#modalAddToCart").attr("tabindex", "-1").focus();
    }, 300);
});

jQuery(document).on("click", ".modal-close > button", function () {
    closeModalAndReturnFocus();
});

jQuery(document).on("keydown", function (e) {
    if (e.key === "Escape" && jQuery("#modalAddToCart").is(":visible")) {
        closeModalAndReturnFocus();
    }
});

function closeModalAndReturnFocus() {
    jQuery('#modalAddToCart').modal('hide');

    setTimeout(function () {
        if (lastFocusedButton) {
            lastFocusedButton.focus();
        }
    }, 300);
}
});